module.exports = __webpack_public_path__ + "img/Upgrade-your-package-th.695950b.png";